import { Component, OnInit } from '@angular/core';
import { InboxService } from '../../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-inbox-associations',
  templateUrl: './inbox-associations.component.html',
  styleUrls: ['./inbox-associations.component.css']
})
export class InboxAssociationsComponent implements OnInit {

  constructor(
    public inboxService: InboxService
  ) {}

  ngOnInit() {
  }

}
